module.exports = __webpack_public_path__ + "static/media/prb-nutri-cartao-visita-02.9600b7ee.jpg";